import React, { Component } from 'react';
import '../App.css';
import Header from '../header/header.js'
import FlechaContact from '../icons/components/flechaContact.js'
class Contact extends Component {

  render() {
    return (
 <div className="contactPadre">
  <div className='contactHijoUno'>
    <div className='contactHijoUnoUno '><h2>You can contact me using the following links:</h2>
    <p>Email: julianstivenm8@gmail.com</p>
  <p>Tel: +57 305 784 39 22</p>   </div>
    <div className='contactHijoUnoDos '>
       <div className='contactBox'>
         <a  href="https://www.facebook.com/julianstiven.madrid" >
         <figure className="ilustracionDos">
         <img className="facebookIcon" src={require("../resources/images/contact/facebookDos.png")} alt="ilustracionLaCasaDelTurbo"/>
         </figure>
         </a>
         <p>Facebook</p>
       </div>
       <div className='contactBox'>
           <a  href="https://twitter.com/JulianM72036500" >
         <figure className="ilustracionDos">
         <img className="facebookIcon" src={require("../resources/images/contact/twitter.png")} alt="ilustracionLaCasaDelTurbo"/>
         </figure>
       </a>
          <p>Twitter</p>
       </div>
       <div className='contactBox'>
            <a  href="https://www.youtube.com/channel/UCqu-G5hLLKuAmwIDKX7N1tA?view_as=subscriber" >
         <figure className="ilustracionDos">
         <img className="facebookIcon" src={require("../resources/images/contact/youtube.png")} alt="ilustracionLaCasaDelTurbo"/>
         </figure>
       </a>
         <p>Youtube</p>
       </div>
       <div className='contactBox'>
            <a  href="https://www.instagram.com/julianstivenmadrid/?hl=es-la" >
         <figure className="ilustracionDos">
         <img className="facebookIcon" src={require("../resources/images/contact/instagram.png")} alt="ilustracionLaCasaDelTurbo"/>
         </figure>
       </a>
         <p>Instagram</p>
       </div>
    </div>
    {/* <div className='contactHijoUnoTres '>
      <div className='contactMensajeUno'>Message*</div>
      <div className='contactMensajeBox'></div>
      <div className='contactMensajeDos'>*Request field</div>
     </div> */}
    {/* <div className='contactHijoUnoCuatro '>
       <div className='send'>Send</div>
       <FlechaContact
         size={45}
         color="white"
       />
    </div> */}
  </div>
 </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/contact/contact.js